angular.module('angus.controllers').controller('sysAdminToolsController', [
    '$rootScope', '$scope', 'windowsService',
    function ($rootScope, $scope, windowsService) {

    }
])